"use client"
import { useState, useEffect } from "react"
import Select from 'react-select'
import axios from 'axios'
import { useAuth } from "../../AuthContext"

const ProjectFormContent = () => {
  const [charCount, setCharCount] = useState(0)
  const [selectedTech, setSelectedTech] = useState([])
  const [currentTech, setCurrentTech] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [technologyOptions, setTechnologyOptions] = useState([])
  const [customProjectType, setCustomProjectType] = useState("")
  const [projectType, setProjectType] = useState("")
  const { user } = useAuth(); // Add this line

  useEffect(() => {
      fetch("http://localhost:5000/skills")
        .then(response => response.json())
        .then(data => {
          const formattedOptions = data.map(skill => ({
            value: skill.skill_id,
            label: skill.skill_name.charAt(0).toUpperCase() + skill.skill_name.slice(1),

          }))
          setTechnologyOptions(formattedOptions)
        })
        .catch(error => console.error("Error fetching skills:", error))
    }, [])

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      title: document.getElementById('projectTitle').value,
      description: document.getElementById('projectDescription').value,
      projectType: projectType === "other" ? customProjectType : projectType,
      budgetRange: `${document.getElementById('budgetMin').value}-${document.getElementById('budgetMax').value}`,
      deadline: document.getElementById('deadline').value,
      note: document.getElementById('additionalNotes').value,
      skills: selectedTech.map(tech => tech.value),
      clientId: user?.secondId // Pass clientId from AuthContext
    };

    console.log("Submitting project data:", formData); // Log request payload

    try {
      const response = await axios.post('http://localhost:5000/add-client-projects', formData);
      alert("Project submitted successfully!");
    } catch (error) {
      console.error("Error submitting project:", error.response?.data || error.message); // Log error response
      alert("Failed to submit project")
    }
  }

  const handleDescriptionChange = (e) => {
    setCharCount(e.target.value.length)
  }

  const addTechnology = () => {
    if (currentTech && !selectedTech.includes(currentTech)) {
      setSelectedTech([...selectedTech, currentTech])
      setCurrentTech("")
    }
  }

  const removeTechnology = (tech) => {
    setSelectedTech(selectedTech.filter((t) => t !== tech))
  }

  const inputStyle = {
    background: 'var(--bg-elevated)', color: 'var(--text-primary)', border: '1px solid var(--border-subtle)',
    borderRadius: '10px', padding: '10px 14px', width: '100%', outline: 'none', fontSize: '0.9rem',
    transition: 'border-color 0.2s',
  };
  const labelStyle = { display: 'block', color: 'var(--text-secondary)', fontSize: '0.8rem', fontWeight: 600, marginBottom: '6px' };

  const selectStyles = {
    control: (base) => ({ ...base, background: 'var(--bg-elevated)', borderColor: 'var(--border-subtle)', borderRadius: '10px', minHeight: '42px', boxShadow: 'none', '&:hover': { borderColor: 'var(--accent-cyan)' } }),
    menu: (base) => ({ ...base, background: 'var(--bg-card)', border: '1px solid var(--border-glass)', borderRadius: '10px' }),
    option: (base, state) => ({ ...base, background: state.isFocused ? 'var(--bg-elevated)' : 'transparent', color: 'var(--text-primary)', cursor: 'pointer' }),
    singleValue: (base) => ({ ...base, color: 'var(--text-primary)' }),
    multiValue: (base) => ({ ...base, background: 'rgba(0,212,255,0.1)', borderRadius: '6px' }),
    multiValueLabel: (base) => ({ ...base, color: 'var(--accent-cyan)' }),
    input: (base) => ({ ...base, color: 'var(--text-primary)' }),
    placeholder: (base) => ({ ...base, color: 'var(--text-muted)' }),
  };

  return (
    <div style={{ background: 'var(--bg-card)', borderRadius: '20px', border: '1px solid var(--border-glass)', padding: '40px', maxWidth: '720px', margin: '40px auto', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, var(--accent-cyan), var(--accent-violet))' }} />
      <h1 style={{ fontSize: '1.6rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)', textAlign: 'center', marginBottom: '6px' }}>Request new Project</h1>
      <p style={{ color: 'var(--text-muted)', textAlign: 'center', marginBottom: '28px', fontSize: '0.9rem' }}>Fill in the details of your project to get started</p>
      <form id="projectForm" className="space-y-6" onSubmit={handleSubmit}>
        <div style={{ padding: '20px', border: '1px solid var(--border-glass)', borderRadius: '14px', background: 'var(--bg-glass)' }}>
          <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '16px' }}>Project</h3>
          <div className="mb-4">
            <label style={labelStyle} htmlFor="projectTitle">Project Title</label>
            <input id="projectTitle" type="text" placeholder="Enter project title" required style={inputStyle}
              onFocus={e => e.target.style.borderColor = 'var(--accent-cyan)'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
          </div>
          <div className="mb-4">
            <label style={labelStyle} htmlFor="projectDescription">Project Description</label>
            <textarea id="projectDescription" placeholder="Briefly describe your project" maxLength={500} rows={4} required onChange={handleDescriptionChange}
              style={{ ...inputStyle, resize: 'vertical' }} onFocus={e => e.target.style.borderColor = 'var(--accent-cyan)'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
            <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '4px' }}><span>{charCount}</span>/500 characters</p>
          </div>
          <div className="mb-4">
            <label style={labelStyle} htmlFor="projectTech">Technology needed</label>
            <div className="flex gap-2">
              <Select
                options={technologyOptions.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase()))}
                value={currentTech}
                onChange={(selectedOption) => setCurrentTech(selectedOption)}
                styles={selectStyles}
                className="flex-1"
              />
              <button type="button" onClick={addTechnology}
                style={{ background: 'linear-gradient(135deg, var(--accent-cyan), var(--accent-violet))', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '10px', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                Add
              </button>
            </div>
            <div className="mt-2 flex flex-wrap gap-2">
              {selectedTech.map((tech) => (
                <span key={tech.value} style={{ display: 'inline-flex', alignItems: 'center', padding: '4px 12px', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: 600, background: 'rgba(0,212,255,0.08)', color: 'var(--accent-cyan)', border: '1px solid rgba(0,212,255,0.15)' }}>
                  {tech.label}
                  <button type="button" onClick={() => removeTechnology(tech)} style={{ marginLeft: '6px', color: 'rgba(0,212,255,0.5)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '1rem' }}>×</button>
                </span>
              ))}
            </div>
          </div>
          <div className="mb-4">
            <label htmlFor="projectType" style={labelStyle}>Project Type</label>
            <select id="projectType" name="projectType" value={projectType} onChange={(e) => setProjectType(e.target.value)}
              style={inputStyle}>
              <option value="">Select project type</option>
              <option value="web">Web Development</option>
              <option value="mobile">Mobile Development</option>
              <option value="data">Data Analysis</option>
              <option value="ml">Machine Learning</option>
              <option value="other">Other</option>
            </select>
            {projectType === "other" && (
              <input type="text" placeholder="Enter custom project type" value={customProjectType} onChange={(e) => setCustomProjectType(e.target.value)}
                style={{ ...inputStyle, marginTop: '8px' }} onFocus={e => e.target.style.borderColor = 'var(--accent-cyan)'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
            )}
          </div>
          <div className="mb-4">
            <label htmlFor="budgetRange" style={labelStyle}>Budget Range</label>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <div style={{ position: 'relative', flex: 1 }}>
                <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)', fontSize: '0.85rem' }}>$</span>
                <input type="number" name="budgetMin" id="budgetMin" placeholder="Min" style={{ ...inputStyle, paddingLeft: '28px' }}
                  onFocus={e => e.target.style.borderColor = 'var(--accent-cyan)'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
              </div>
              <span style={{ color: 'var(--text-muted)' }}>—</span>
              <div style={{ position: 'relative', flex: 1 }}>
                <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)', fontSize: '0.85rem' }}>$</span>
                <input type="number" name="budgetMax" id="budgetMax" placeholder="Max" style={{ ...inputStyle, paddingLeft: '28px' }}
                  onFocus={e => e.target.style.borderColor = 'var(--accent-cyan)'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
              </div>
            </div>
          </div>
          <div className="mb-4">
            <label htmlFor="deadline" style={labelStyle}>Deadline</label>
            <input type="date" name="deadline" id="deadline" style={inputStyle}
              onFocus={e => e.target.style.borderColor = 'var(--accent-cyan)'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
          </div>
          <div className="mb-4">
            <label htmlFor="additionalNotes" style={labelStyle}>Additional Notes</label>
            <textarea id="additionalNotes" name="additionalNotes" rows={3} placeholder="Add any extra details or preferences for Professionals"
              style={{ ...inputStyle, resize: 'vertical' }} onFocus={e => e.target.style.borderColor = 'var(--accent-cyan)'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
          </div>
        </div>
        <div className="flex items-center justify-between">
          <button type="submit"
            style={{ background: 'linear-gradient(135deg, var(--accent-cyan), var(--accent-violet))', color: '#fff', border: 'none', padding: '12px 32px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer', fontSize: '0.95rem', transition: 'opacity 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.85'} onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
            Post Project
          </button>
        </div>
      </form>
    </div>
  )
}

export default ProjectFormContent

